import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/pathBuilder';
import { TYPES } from 'constants/config';
import Icon from 'ui/Icon';
import DemonstrationInfoCard from './Form/DemonstrationInfoCard';
import DemonstrationPromptCard from './Form/DemonstrationPromptCard';

const DemonstrationBuilder = ({
  hideDemonstrationBuilder,
  demonstration,
  id,
}) => {
  return (
    <div className="DemonstrationBuilder container ff-ss">
      <div className="pb-16">
        <button
          type="button"
          className="u-linkBtn fz-16 lh-24 c-brand-blue"
          onClick={hideDemonstrationBuilder}
        >
          <Icon name="back" className="mr-4" />
          {t('demonstrations.go_back_to_certification_builder')}
        </button>
      </div>
      <h1 className="ff-ss pb-16">
        {t('demonstrations.demonstration_builder.demonstration_builder')}
      </h1>
      <DemonstrationInfoCard demonstration={demonstration} id={id} />
      <DemonstrationPromptCard demonstration={demonstration} id={id} />
    </div>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }, { id }) => ({
  contents: pathBuilder.contents,
  demonstration: pathBuilder.contents.find(
    content => content.type === TYPES.DEMONSTRATION && content.id === id,
  ),
});

const mapDispatchToProps = {
  hideDemonstrationBuilder: actions.hideDemonstrationBuilder,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemonstrationBuilder);
